const getSubmissionButtonLabel = ({
  isLastStep,
  comingFromView,
  integrationType,
  nextLabel,
  displaySubmissionModal
}) => {
  if (isLastStep && displaySubmissionModal) {
    return `${comingFromView ? 'Resubmit' : 'Submit'} to ${integrationType}`;
  }
  return nextLabel;
};

export default getSubmissionButtonLabel;
